const ALLOWED_TAGS = new Set([
  "DIV",
  "P",
  "BR",
  "SPAN",
  "B",
  "STRONG",
  "I",
  "EM",
  "U",
  "S",
  "SUB",
  "SUP",
  "UL",
  "OL",
  "LI",
  "A",
  "BLOCKQUOTE",
  "PRE",
  "CODE",
  "H1",
  "H2",
  "H3",
  "H4",
  "H5",
  "H6",
  "TABLE",
  "THEAD",
  "TBODY",
  "TR",
  "TH",
  "TD",
  "HR",
]);
const ALLOWED_ATTRS = new Set(["href", "target", "rel", "class", "style"]);
const REMOVE_ENTIRELY = new Set([
  "SCRIPT",
  "STYLE",
  "NOSCRIPT",
  "IFRAME",
  "OBJECT",
  "EMBED",
]);

export function sanitizeHtmlToFragment(html: string): DocumentFragment {
  const template = document.createElement("template");
  template.innerHTML = html;
  const frag = template.content;

  for (const el of [...frag.querySelectorAll("*")]) {
    if (REMOVE_ENTIRELY.has(el.tagName)) {
      el.remove();
      continue;
    }
    if (!ALLOWED_TAGS.has(el.tagName)) {
      el.replaceWith(...el.childNodes);
      continue;
    }
    for (const attr of [...el.attributes]) {
      if (
        !ALLOWED_ATTRS.has(attr.name) ||
        (attr.name === "href" && /^\s*javascript:/i.test(attr.value))
      ) {
        el.removeAttribute(attr.name);
      }
    }
  }

  return frag;
}

export function sanitizeHtml(html: string): string {
  const frag = sanitizeHtmlToFragment(html);
  const container = document.createElement("div");
  container.appendChild(frag);
  return container.innerHTML;
}
